import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import React, { useMemo } from "react";
import ErrorDetails from "../components/ErrorDetails";
import useBoundComponent from "../hooks/useBoundComponent";
import Layout from "./Layout";

type Props = {
  children?: React.ReactNode;
  error: Error;
};

const ErrorPage: React.FC<Props> = (props) => {
  const { error, children } = props;
  return (
    <Layout logo>
      <Container
        maxWidth="sm"
        sx={{ display: "flex", flexDirection: "column", gap: 2 }}
      >
        {children || (
          <Typography variant="h5" textAlign="center">
            Oops! An error has occurred.
          </Typography>
        )}
        <ErrorDetails error={error} />
      </Container>
    </Layout>
  );
};

export default ErrorPage;

export const useBoundErrorPage = (
  explainer: React.ReactNode,
): React.FC<Pick<Props, "error">> => {
  const bound = useMemo(() => ({ children: explainer }), [explainer]);
  return useBoundComponent(ErrorPage, bound);
};
